import {BsBuilding, BsHouseDoor} from "react-icons/bs";
import {FaRegBuilding} from "react-icons/fa";
import {FiGrid, FiMaximize2} from "react-icons/fi";

const roomTypesData = [
    {
        id: 1,
        name: 'Duplex Houses',
        size: 'Approx. 110-180 m² built',
        description: 'Modern semi-detached homes offering spacious living across multiple floors, often including private gardens or terraces.',
        features: ['Multiple Bedrooms (3-4 typical)', 'Multiple Bathrooms', 'Living Area + Kitchen', 'Private Entrance', 'Often includes Terrace/Balcony/Garden', 'Underfloor Heating (Common)'],
        image: 'https://arcdom.b-cdn.net/arcdom-projects/duplex-iazului/3.png',
        icon: <BsHouseDoor />,
    },
    {
        id: 2,
        name: '2-Room Apartments',
        size: 'Approx. 45-60 m²',
        description: 'Comfortable and functional apartments ideal for individuals or couples, featuring separate living and sleeping areas.',
        features: ['1 Bedroom', 'Living + Kitchen Area', 'Bathroom', 'Balcony/Terrace (Common)', 'Underfloor Heating (Common)', 'Semi-finished option typical'],
        image: 'https://arcdom.b-cdn.net/arcdom-projects/apartamente-padurii/1.png',
        icon: <BsBuilding />,
    },
    {
        id: 3,
        name: '3-Room Apartments',
        size: 'Approx. 65-85 m²',
        description: 'Spacious apartments suitable for families, offering two separate bedrooms and generous living spaces.',
        features: ['2 Bedrooms', 'Living + Kitchen Area', '1-2 Bathrooms', 'Balcony/Terrace (Common)', 'Underfloor Heating (Common)', 'Semi-finished option typical'],
        image: 'https://arcdom.b-cdn.net/arcdom-projects/apartamente-grigorescu/1.png',
        icon: <FaRegBuilding />,
    },
    {
        id: 4,
        name: 'Penthouse Apartments',
        size: 'Approx. 50 m² + Large Terrace',
        description: 'Exclusive top-floor apartments often featuring large private terraces and premium views or finishes.',
        features: ['Top Floor Location', 'Expansive Terrace', 'Often 2 Rooms', 'Premium Potential', 'Elevator Access (Common in buildings)'],
        image: 'https://arcdom.b-cdn.net/arcdom-projects/someseni/2.jpeg',
        icon: <FiMaximize2 />,
    },
    {
        id: 5,
        name: 'Residential Complexes',
        size: 'Multiple Units',
        description: 'Integrated living environments featuring multiple apartment buildings or houses, often with shared amenities.',
        features: ['Mix of Apartment/Duplex Types', 'Common Green Spaces', 'Playgrounds (Common)', 'Parking Solutions (Surface/Underground)', 'Potential Commercial Spaces'],
        image: 'https://arcdom.b-cdn.net/arcdom-projects/sesul-de-sus/1.png',
        icon: <FiGrid />,
    },
];

export default roomTypesData;
